var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticStyle:{"margin-top":"50px"}},[_vm._v(" Đây là page Phân công nhân viên Token: "),_c('pre',[_vm._v("  "+_vm._s(_vm.access_token)+"\n  ")])])}
var staticRenderFns = []

export { render, staticRenderFns }